/**
 * Custom agent service — a user's persistent, reusable "My Agents" (CRUD). A custom
 * agent can be added to any chat and carry its own knowledge base (see knowledgeService).
 */
import { callFunction } from '../utils/apiClient';

export interface CustomAgent {
  id: string;
  owner_id: string;
  name: string;
  persona: string;
  description: string;
  /** Short plain-language specialisation, woven into the effective prompt at generation. */
  focus?: string;
  avatar_icon: string;
  avatar_url: string | null;
  system_prompt: string;
  model_tier: 'SMART' | 'EXPERT' | 'RESEARCH';
  temperature: number;
  tools: string[];
  knowledge_backend: 'none' | 'simple' | 'vector';
  /** 'private' (subscriber-only) hides the agent's config from other chat participants. */
  visibility: 'public' | 'private';
  created_at: string;
  updated_at: string;
}

export type CustomAgentInput = Partial<Omit<CustomAgent, 'id' | 'owner_id' | 'created_at' | 'updated_at'>>;

export const listCustomAgents = () =>
  callFunction<{ agents: CustomAgent[] }>('listCustomAgents', {}).then((r) => r.agents || []);

export const createCustomAgent = (input: CustomAgentInput) =>
  callFunction<CustomAgent>('createCustomAgent', input);

export const updateCustomAgent = (agentId: string, patch: CustomAgentInput) =>
  callFunction<CustomAgent>('updateCustomAgent', { agentId, ...patch });

export const deleteCustomAgent = (agentId: string) =>
  callFunction<{ deleted: boolean }>('deleteCustomAgent', { agentId });
